import { Typography } from "@mui/material";
import { AppUser } from "../../../../types/AppUser";

export default function AppUserRoleWarnings(props: { user: AppUser | undefined }) {
    if (!props.user?.isSSOUser) return null;

    return (
        <Typography color="warning.main" fontWeight={"bold"} mb={2}>
            This user uses Single Sign On. Roles assigned on this page are likely to be overridden
        </Typography>
    );
}